<form [formGroup]="formGroup">
    <div class="d-flex year-month-filter-container">
        <kendo-daterange>
            <kendo-floatinglabel class="float-label-color" [text]="labelText">
                <input kendoTextBox
                       #anchorInput
                       class="k-textbox"
                       (click)="popup.toggle()"
                       [value]="getDisplayDateRange()"
                       (keydown.enter)="onManualBlur($event)" />
            </kendo-floatinglabel>
            <kendo-daterange-popup #popup [anchor]="anchor()">
                <ng-template kendoDateRangePopupTemplate>
                    @if (!isMonthYear) {
                    <kendo-multiviewcalendar [selection]="'range'"
                                             [(value)]="selectedRange"
                                             [showViewHeader]="true"
                                             (valueChange)="onDateRangeChange($event, popup)">
                    </kendo-multiviewcalendar>
                    }
                    @if (isMonthYear) {
                    <kendo-multiviewcalendar [activeView]="'year'"
                                             [topView]="'decade'"
                                             [bottomView]="'year'"
                                             [selection]="'range'"
                                             [showViewHeader]="true"
                                             [(value)]="monthRange"
                                             (valueChange)="onMonthClick($event, popup)">
                    </kendo-multiviewcalendar>
                    }
                </ng-template>
            </kendo-daterange-popup>
        </kendo-daterange>
    </div>
</form>
